module.exports = __webpack_public_path__ + "img/pramod-pic.906db3ae.jpg";